module.exports = __webpack_public_path__ + "img/backyard-pond-straight-on.db5865dc.jpg";